import { render, staticRenderFns } from "./HeaderNotifications.vue?vue&type=template&id=6057fc57&scoped=true&"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js&"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6057fc57",
  null
  
)

export default component.exports